import { RoutesPaths } from "../../constants/routes"

/**
 * Whether the address is the public, no-login customer guide page. Exact
 * match only — unlike the shared-file page, this route carries no id in the
 * path (the token travels in the URL fragment instead, read and discarded by
 * the page itself), so there is no sub-path to allow for.
 */
export const isProjectEducationPath = (pathname: string) =>
  pathname === RoutesPaths.projectEducation
